import { FlowDefinition } from "../../../core/flows/FlowDefinition";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { LoyaltyProgramDetailStepDeclaration } from "./Steps/LoyaltyProgramDetailInitStep";

const loyaltyProgramDetailStartupFlow = new FlowDefinition("LoyaltyProgramDetailFlow");

loyaltyProgramDetailStartupFlow.addStep(LoyaltyProgramDetailStepDeclaration);

loyaltyProgramDetailStartupFlow.setStartStep("LoyaltyProgramDetailInit_Step");

export const loyaltyProgramDetailStartupFlowDefinition = new StepDefinition({
    stepName: "LoyaltyProgramDetailFlow",
    stepFlow: loyaltyProgramDetailStartupFlow,
    contextIsolation: false
})